<template>
   <v-container fluid class="pa-6">
      <v-card elevation="2">
         <div class="px-6 pt-5 pb-2">
            <span class="text-h5 font-weight-medium">
               Configuraciones de colecturía digital —
               <span class="primary--text">{{ sedeNombre }}</span>
            </span>
         </div>

         <v-tabs v-model="tabActivo" class="tabs-outline px-4 pt-2 pb-1">
            <v-tab>
               <v-icon left small>fa-university</v-icon>
               Colecturía Digital
            </v-tab>
            <v-tab>
               <v-icon left small>fa-file-invoice-dollar</v-icon>
               Plan de Pagos
            </v-tab>
            <v-tab>
               <v-icon left small>fa-graduation-cap</v-icon>
               Becas
            </v-tab>
            <!-- Sección de Idiomas comentada / deshabilitada
            <v-tab>
               <v-icon left small>fa-language</v-icon>
               Idiomas
            </v-tab>
            -->
            <v-tab>
               <v-icon left small>fa-tools</v-icon>
               Mantenimiento
            </v-tab>
         </v-tabs>

         <v-divider></v-divider>

         <v-card-text class="text--primary">
            <!-- SECCIÓN DE IDIOMAS COMENTADA / DESHABILITADA
                 (las fechas de idiomas ahora se gestionan en Calendarización de Módulos).
                 Para reactivarla: restaurar el botón de la pestaña, cambiar este v-if a
                 "tabActivo === 3" y devolver Mantenimiento a "tabActivo === 4". -->
            <div v-if="false" class="pa-4">

               <!-- Sección: Estado general -->
               <div class="overline grey--text text--darken-1 mb-2">Estado</div>
               <v-card outlined class="mb-6">
                  <v-list-item v-if="getConfigItem('pagosIdiomas')">
                     <v-list-item-icon class="mr-4 my-auto">
                        <v-icon color="primary">fa-language</v-icon>
                     </v-list-item-icon>
                     <v-list-item-content>
                        <v-list-item-title class="font-weight-medium body-2">
                           {{ getNombre('pagosIdiomas') }}
                        </v-list-item-title>
                     </v-list-item-content>
                     <v-list-item-action>
                        <v-checkbox
                           v-model="getConfigItem('pagosIdiomas').valor"
                           color="primary"
                           hide-details
                        ></v-checkbox>
                     </v-list-item-action>
                  </v-list-item>
               </v-card>

               <!-- Sección: Fechas de inscripción -->
               <div class="overline grey--text text--darken-1 mb-2">Fechas de inscripción y activación</div>
               <v-row dense class="mb-4">
                  <v-col v-if="getConfigItem('vencimientoInscripcionIdiomas')" cols="12" sm="4">
                     <v-card outlined class="pa-4 fill-height">
                        <div class="caption primary--text font-weight-medium mb-3">
                           <v-icon x-small color="primary" class="mr-1">fa-calendar-alt</v-icon>
                           Sabatino
                        </div>
                        <div class="caption black--text mb-3" style="min-height: 36px">{{ getNombre('vencimientoInscripcionIdiomas') }}</div>
                        <CustomDatePicker
                           :date="getConfigItem('vencimientoInscripcionIdiomas').valor"
                           label="Seleccionar fecha"
                           min="2020-01-01"
                           clearable
                           @updateFecha="getConfigItem('vencimientoInscripcionIdiomas').valor = $event"
                        />
                     </v-card>
                  </v-col>
                  <v-col v-if="getConfigItem('vencimientoInscripcionIdiomasInt')" cols="12" sm="4">
                     <v-card outlined class="pa-4 fill-height">
                        <div class="caption primary--text font-weight-medium mb-3">
                           <v-icon x-small color="primary" class="mr-1">fa-calendar-alt</v-icon>
                           Intensivo
                        </div>
                        <div class="caption black--text mb-3" style="min-height: 36px">{{ getNombre('vencimientoInscripcionIdiomasInt') }}</div>
                        <CustomDatePicker
                           :date="getConfigItem('vencimientoInscripcionIdiomasInt').valor"
                           label="Seleccionar fecha"
                           min="2020-01-01"
                           clearable
                           @updateFecha="getConfigItem('vencimientoInscripcionIdiomasInt').valor = $event"
                        />
                     </v-card>
                  </v-col>
                  <v-col v-if="getConfigItem('fechaActivacionPagosIdiomas')" cols="12" sm="4">
                     <v-card outlined class="pa-4 fill-height">
                        <div class="caption primary--text font-weight-medium mb-3">
                           <v-icon x-small color="primary" class="mr-1">fa-bolt</v-icon>
                           Activación de pagos
                        </div>
                        <div class="caption black--text mb-3" style="min-height: 36px">{{ getNombre('fechaActivacionPagosIdiomas') }}</div>
                        <CustomDatePicker
                           :date="getConfigItem('fechaActivacionPagosIdiomas').valor"
                           label="Seleccionar fecha"
                           min="2020-01-01"
                           clearable
                           @updateFecha="getConfigItem('fechaActivacionPagosIdiomas').valor = $event"
                        />
                     </v-card>
                  </v-col>
               </v-row>

               <!-- Sección: EBOOK -->
               <template v-if="configIdiomasEbook.length > 0">
                  <div class="overline grey--text text--darken-1 mb-2">Configuración EBOOK</div>
                  <v-row dense>
                     <v-col
                        v-for="item in configIdiomasEbook"
                        :key="item.nombre"
                        cols="12"
                        sm="6"
                     >
                        <v-card outlined class="pa-4">
                           <div class="caption primary--text font-weight-medium mb-2">{{ item.nombre }}</div>
                           <v-textarea
                              v-model="item.valor"
                              color="primary"
                              rows="1"
                              outlined
                              dense
                              hide-details
                           ></v-textarea>
                        </v-card>
                     </v-col>
                  </v-row>
               </template>
            </div>

            <!-- Layout especial para tab Mantenimiento (índice 3 tras ocultar Idiomas) -->
            <div v-else-if="tabActivo === 3" class="pa-4">
               <div class="overline grey--text text--darken-1 mb-2">Estado actual</div>
               <v-card outlined class="mb-6 pa-4">
                  <v-list-item class="px-0">
                     <v-list-item-icon class="mr-4 my-auto">
                        <v-icon color="primary">fa-tools</v-icon>
                     </v-list-item-icon>
                     <v-list-item-content>
                        <v-list-item-title class="font-weight-medium body-2">
                           Mantenimiento — Activado desde
                        </v-list-item-title>
                        <v-list-item-subtitle class="mt-1">
                           {{ formatearFechaMantenimiento(getConfigItem('mantenimientoDesde') && getConfigItem('mantenimientoDesde').valor) }}
                        </v-list-item-subtitle>
                     </v-list-item-content>
                  </v-list-item>
               </v-card>
               <BitacoraMantenimiento ref="bitacora" />
            </div>

            <!-- Data table para el resto de tabs -->
            <v-data-table
               v-else
               :headers="headersConfig"
               :items="configFiltrado"
               :items-per-page="-1"
               :footer-props="{ itemsPerPageOptions: [-1] }"
               no-results-text="Búsqueda sin resultados"
               class="elevation-0"
               hide-default-footer
               fixed-header
            >
               <template #item.nombre="{ item }">
                  {{ getNombre(item.nombre) }}
               </template>

               <template #item.valor="{ item }">
                  <div
                     v-if="typeof item.valor === 'boolean'"
                     class="layout justify-center"
                  >
                     <v-checkbox
                        v-model="item.valor"
                        color="primary"
                        style="margin-left: 5px"
                     ></v-checkbox>
                  </div>

                  <v-text-field
                     v-else-if="item.nombre === 'mantenimientoDesde'"
                     :value="formatearFechaMantenimiento(item.valor)"
                     readonly
                     disabled
                     color="primary"
                     dense
                     hide-details
                  ></v-text-field>

                  <CustomDatePicker
                     v-else-if="esFecha(item.nombre)"
                     :date="item.valor"
                     label=""
                     min="2020-01-01"
                     clearable
                     @updateFecha="item.valor = $event"
                  />

                  <v-autocomplete
                     v-else-if="item.nombre === 'carrerasPlanPagos'"
                     v-model="item.valor"
                     :items="cmbCarreraUniversitaria"
                     color="primary"
                     item-value="codigo"
                     item-text="nombre"
                     multiple
                     chips
                     small-chips
                     deletable-chips
                     no-data-text="Sin resultados"
                     placeholder="Seleccionar carreras..."
                  >
                     <template #item="{ item: carrera }">
                        <v-list-item-content style="width: 0px">
                           <v-list-item-title
                              class="wrap-list-title"
                              v-text="carrera.nombre.trim()"
                           ></v-list-item-title>
                           <v-list-item-subtitle
                              v-text="'Código ' + carrera.codigo"
                           ></v-list-item-subtitle>
                        </v-list-item-content>
                     </template>
                  </v-autocomplete>

                  <v-autocomplete
                     v-else-if="esCiclo(item.nombre)"
                     v-model="item.valor"
                     :items="cmbCiclos"
                     color="primary"
                     item-text="nombre"
                     item-value="nombre"
                     no-data-text="Sin resultados"
                     placeholder="Seleccionar ciclo..."
                     clearable
                     dense
                     hide-details
                  ></v-autocomplete>

                  <v-textarea
                     v-else-if="['mensaje', 'mensajePlanPagos', 'mensajeBecas'].includes(item.nombre)"
                     v-model="item.valor"
                     color="primary"
                     rows="4"
                     auto-grow
                     outlined
                     class="mt-2"
                  ></v-textarea>

                  <v-textarea
                     v-else-if="typeof item.valor === 'string'"
                     v-model="item.valor"
                     color="primary"
                     rows="1"
                     label=""
                  ></v-textarea>
               </template>

               <template slot="no-data">
                  <div v-if="detallesConfig.length == 0">
                     <v-container>
                        <v-layout wrap align-center>
                           <v-flex xs12 class="text-center">
                              <v-btn color="primary">Sin opciones</v-btn>
                           </v-flex>
                        </v-layout>
                     </v-container>
                  </div>
               </template>
            </v-data-table>
         </v-card-text>

         <v-card-actions style="padding: 0px 40px 20px 40px">
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click.stop="close">Salir</v-btn>
            <v-btn color="primary" dark @click.stop="guardarConfig">Guardar</v-btn>
         </v-card-actions>
      </v-card>
   </v-container>
</template>

<script>
import axios from 'axios'
import formatters from '../mixins/formattersLib'
import { authComputed } from '../helpers'
import { mask } from 'vue-the-mask'
import CustomDatePicker from './custom/CustomDatePicker'
import BitacoraMantenimiento from './BitacoraMantenimiento'

const TABS = {
   colecturiaDigital: 0,
   planPagos: 1,
   becas: 2,
   // idiomas: sección comentada / deshabilitada
   mantenimiento: 3
}

const NOMBRES_COLECTURIA_DIGITAL = ['pagosEnLinea', 'mensaje', 'periodoDiferidos']
const NOMBRES_PLAN_PAGOS = ['formPlanPagos', 'carrerasPlanPagos', 'mensajePlanPagos', 'fechaInicioAbs', 'fechaFinAbs', 'cicloActual', 'cicloExonerado']
const NOMBRES_BECAS = ['formBecasPreevaluacion', 'mensajeBecas', 'fechaLimiteBecas']
const NOMBRES_IDIOMAS = ['pagosIdiomas', 'vencimientoInscripcionIdiomas', 'vencimientoInscripcionIdiomasInt', 'fechaActivacionPagosIdiomas']
const NOMBRES_MANTENIMIENTO = ['mantenimientoDesde']

const NOMBRES_CICLOS = ['cicloActual', 'cicloExonerado']

const NOMBRES_FECHAS = [
   'fechaInicioAbs',
   'fechaFinAbs',
   'fechaLimiteBecas',
   'vencimientoInscripcionIdiomas',
   'vencimientoInscripcionIdiomasInt',
   'fechaActivacionPagosIdiomas'
]

export default {
   name: 'Configuracion',
   directives: {
      mask
   },
   components: {
      CustomDatePicker,
      BitacoraMantenimiento
   },
   mixins: [formatters],
   data: () => ({
      tabActivo: 0,
      detallesConfig: [],
      cmbCarreraUniversitaria: [],
      cmbCiclos: [],
      headersConfig: [
         {
            text: 'Nombre',
            value: 'nombre',
            class: 'titulo',
            width: 250,
            sortable: false
         },
         {
            text: 'Activo / Valor',
            value: 'valor',
            align: 'center',
            class: 'titulo',
            sortable: false
         }
      ]
   }),
   computed: {
      ...authComputed,
      sedeNombre() {
         return process.env.VUE_APP_SEDE === 'SA' ? 'Santa Ana' : 'Ilobasco'
      },
      configFiltrado() {
         return this.detallesConfig.filter((el) => {
            const tab = this.getTabDeNombre(el.nombre)
            if (tab !== this.tabActivo) return false
            // No mostrar las configuraciones sin nombre definido (aparecen como "NO CONFIGURADO")
            return this.getNombre(el.nombre) !== 'NO CONFIGURADO'
         })
      },
      configIdiomasEbook() {
         return this.detallesConfig.filter((el) => el.nombre.includes('EBOOK'))
      }
   },
   mounted() {
      axios.get('api/general/CarreraUniversitaria').then((response) => {
         this.cmbCarreraUniversitaria = response.data
      }).catch((error) => {
         console.log(error.response)
      })
      axios.get('api/Ciclos').then((response) => {
         this.cmbCiclos = response.data
      }).catch((error) => {
         console.log(error.response)
      })
      axios
         .get('api/Configuracion')
         .then((response) => {
            var res = response.data
            res.forEach((el) => {
               switch (el.valor) {
                  case 'true':
                     el.valor = true
                     break
                  case 'false':
                     el.valor = false
                     break
                  default:
                     if (el.valor === null) {
                        el.valor = ''
                     }
                     break
               }
               if (el.nombre === 'carrerasPlanPagos') {
                  el.valor = el.valor
                     ? el.valor.split(',').map((c) => c.trim()).filter(Boolean)
                     : []
               }
            })
            this.detallesConfig = res
         })
         .catch((error) => {
            console.log(error.response)
         })
   },
   methods: {
      getConfigItem(nombre) {
         return this.detallesConfig.find((el) => el.nombre === nombre)
      },
      esCiclo(nombre) {
         return NOMBRES_CICLOS.includes(nombre)
      },
      esFecha(nombre) {
         return NOMBRES_FECHAS.includes(nombre)
      },
      getTabDeNombre(nombre) {
         if (NOMBRES_COLECTURIA_DIGITAL.includes(nombre)) return TABS.colecturiaDigital
         if (NOMBRES_PLAN_PAGOS.includes(nombre)) return TABS.planPagos
         if (NOMBRES_BECAS.includes(nombre)) return TABS.becas
         // Sección de Idiomas comentada: sus configuraciones no se muestran en ninguna pestaña
         if (NOMBRES_IDIOMAS.includes(nombre) || nombre.includes('EBOOK')) return -1
         if (NOMBRES_MANTENIMIENTO.includes(nombre)) return TABS.mantenimiento
         return TABS.colecturiaDigital
      },
      guardarConfig() {
         const promesas = this.detallesConfig.map((config) => {
            const stringValor = config.valor.toString()
            let url = `api/Configuracion/${config.nombre}?value=${stringValor}`
            if (config.nombre === 'pagosEnLinea') {
               const usuario = this.oidcUser ? this.oidcUser.name : 'Desconocido'
               url += `&usuario=${encodeURIComponent(usuario)}`
            }
            return axios.put(url).catch(() => {})
         })
         Promise.all(promesas).then(() => {
            if (this.$refs.bitacora) this.$refs.bitacora.cargarBitacora()
         })
         this.close()
      },
      close() {
         this.$router.go(-1)
      },
      formatearFechaMantenimiento(valor) {
         if (!valor) return '—'
         const d = new Date(valor)
         if (isNaN(d)) return valor
         const pad = n => String(n).padStart(2, '0')
         return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}  ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
      },
      getNombre(nombre) {
         switch (true) {
            case nombre == 'pagosEnLinea':
               return 'Funciones de pago en linea en colecturía digital.'

            case nombre == 'formPlanPagos':
               return 'Recepción de formularios para nuevos planes de pago.'

            case nombre == 'formBecasPreevaluacion':
               return 'Formulario de preevaluación para solicitudes de becas.'

            case nombre == 'carrerasPlanPagos':
               return 'Códigos de carreras para recepción de planes de pagos'

            case nombre == 'mensaje':
               return 'Mensaje para Colecturía Digital y de Usuarios Externos.'

            case nombre == 'mensajePlanPagos':
               return 'Mensaje para formulario de Plan de Pagos.'

            case nombre == 'mensajeBecas':
               return 'Mensaje para formulario de Becas.'

            case nombre == 'fechaInicioAbs':
               return 'Fecha de inicio de absolución de mora.'

            case nombre == 'fechaFinAbs':
               return 'Fecha de finalización de absolución de mora.'

            case nombre == 'cicloActual':
               return 'Ciclo actual para validación de formularios de planes de pago y becas.'

            case nombre == 'cicloExonerado':
               return 'Exonerar ciclo mora de ciclo.'

            case nombre == 'pagosIdiomas':
               return 'Funciones de pagos de módulos de idiomas.'

            case nombre == 'vencimientoInscripcionIdiomas':
               return 'Fecha de finalizacion de inscripcion de modulos de idiomas sabatino.'

            case nombre == 'vencimientoInscripcionIdiomasInt':
               return 'Fecha de finalizacion de inscripcion de modulos de idiomas intensivo.'

            case nombre.includes('EBOOK') === true:
               return nombre

            case nombre == 'periodoDiferidos':
               return 'Filtro de periodo al listar exámenes de diferidos'

            case nombre == 'fechaLimiteBecas':
               return 'Fecha limite para completar solicitud de becas. (Para notificación por correo)'

            case nombre == 'fechaActivacionPagosIdiomas':
               return 'Fecha de activacion pagos idiomas'

            case nombre == 'mantenimientoDesde':
               return 'Mantenimiento — Activado desde'

            default:
               return 'NO CONFIGURADO'
         }
      }
   }
}
</script>

<style scoped>
/* ── Tabs como botones outline ── */
.tabs-outline ::v-deep .v-tabs-bar {
   background-color: transparent !important;
   height: auto !important;
}

.tabs-outline ::v-deep .v-tab {
   border: 2px solid #6C1C19 !important;
   border-radius: 8px !important;
   margin-right: 10px !important;
   color: #6C1C19 !important;
   min-width: unset !important;
   padding: 0 24px !important;
   height: 44px !important;
   font-size: 14px !important;
   font-weight: 600 !important;
   letter-spacing: 0 !important;
}

.tabs-outline ::v-deep .v-tab--active {
   background-color: #6C1C19 !important;
   color: #FFFFFF !important;
}

.tabs-outline ::v-deep .v-tab:hover:not(.v-tab--active) {
   background-color: rgba(108, 28, 25, 0.08) !important;
}

.tabs-outline ::v-deep .v-tabs-slider-wrapper {
   display: none !important;
}
</style>
